var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "7px",
    viewBox: "0 0 13 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrowDownWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.57406932,3.2538068 C9.58725959,3.46563257 9.51587012,3.68171217 9.35990093,3.84749201 L4.2410627,9.28831107 C3.97508724,9.5710167 3.53029333,9.58457918 3.2475877,9.31860371 C3.23718468,9.30881633 3.22708244,9.29871409 3.21729506,9.28831107 C2.92968017,8.98260488 2.92968017,8.50585346 3.21729506,8.20014726 L7.87091731,3.2538068 L3.21729506,-1.69253366 C2.92968017,-1.99823985 2.92968017,-2.47499128 3.21729506,-2.78069747 C3.48327053,-3.0634031 3.92806443,-3.07696558 4.21077006,-2.81099011 C4.22117308,-2.80120273 4.23127532,-2.79110049 4.2410627,-2.78069747 L9.35990093,2.66012159 C9.51587012,2.82590143 9.58725959,3.04198103 9.57406932,3.2538068 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrowDownWhite",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(6.288598, 3.253807) scale(-1, 1) rotate(90.000000) translate(-6.288598, -3.253807) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrowDownWhite.f105264a310f5bb25230bdd2a3c6a69f.svg";
export { ForwardRef as ReactComponent };